export { default } from './geoloc-tags';